import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { isNilOrEmpty, toBoolean } from '@shared/helpers/utils.helper';
import { toNum } from '@shared/helpers/math.helper';
import { addRemoveError, getControl, getFormArray } from '@shared/helpers/form.helper';
import { FormGroup } from '@angular/forms';
import { FormValidationError } from '@shared/models/interfaces/form-validation-error.interface';
import { isEqual } from 'lodash-es';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { getBaseSocialeControl, getBaseSocialeGroup } from './helpers/base-sociale-form.helper';

export const baseSocialeContrattiRules: FormGroupRules = {
    my_CkUtilizzaContrattiSecondoLivello: (form: FormGroup) => {
        const my_CkUtilizzaContrattiSecondoLivelloControl = getBaseSocialeControl(form, 'my_CkUtilizzaContrattiSecondoLivello');
        const my_CkUtilizzaContrattiSecondo = my_CkUtilizzaContrattiSecondoLivelloControl?.value;
        const my_UnitaNonSociUtil = toNum(getBaseSocialeControl(form, 'my_UnitaNonSociUtil')?.value);
        const my_UnitaSociUtil = toNum(getBaseSocialeControl(form, 'my_UnitaSociUtil')?.value);
        const my_NumLavSubTempoDeterminato = toNum(getBaseSocialeControl(form, 'my_NumLavSubTempoDeterminato')?.value);
        const my_NumLavSub = toNum(getBaseSocialeControl(form, 'my_NumLavSub')?.value);
        const errors = my_CkUtilizzaContrattiSecondoLivelloControl.errors ? my_CkUtilizzaContrattiSecondoLivelloControl.errors : {};
        const showError = isNilOrEmpty(my_CkUtilizzaContrattiSecondo) && my_UnitaNonSociUtil + my_UnitaSociUtil > 0 && my_NumLavSubTempoDeterminato + my_NumLavSub > 0;

        addRemoveError(showError, errors, 'my_CkUtilizzaContrattiSecondoLivello', {
            status: REQUIRED_STATUS,
        });

        my_CkUtilizzaContrattiSecondoLivelloControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkUtilizzaContrattiSecondoLivelloAziendali: (form: FormGroup) => {
        myCkUtilizzaContrattiHelper(form, 'my_CkUtilizzaContrattiSecondoLivelloAziendali', {
            status: 'Selezionare almeno una tipologia di contratto',
        });
    },

    my_CkUtilizzaContrattiSecondoLivelloTerrProvinciale: (form: FormGroup) => {
        myCkUtilizzaContrattiHelper(form, 'my_CkUtilizzaContrattiSecondoLivelloTerrProvinciale');
    },

    my_CkUtilizzaContrattiSecondoLivelloTerrRegionale: (form: FormGroup) => {
        myCkUtilizzaContrattiHelper(form, 'my_CkUtilizzaContrattiSecondoLivelloTerrRegionale');
    },

    my_CkContrattiSecondoLivelloRegFiscaleAgevolato: (form: FormGroup) => {
        const my_CkContrattiSecondoLivelloRegFiscaleAgevolatoControl = getBaseSocialeControl(form, 'my_CkContrattiSecondoLivelloRegFiscaleAgevolato');
        const my_CkContrattiSecondoLivelloRegFiscaleAgevolato: string = my_CkContrattiSecondoLivelloRegFiscaleAgevolatoControl?.value;
        const my_CkUtilizzaContrattiSecondoLivello: string = getBaseSocialeControl(form, 'my_CkUtilizzaContrattiSecondoLivello')?.value;
        const my_UnitaNonSociUtil = toNum(getBaseSocialeControl(form, 'my_UnitaNonSociUtil')?.value);
        const my_UnitaSociUtil = toNum(getBaseSocialeControl(form, 'my_UnitaSociUtil')?.value);
        const my_NumLavSubTempoDeterminato = toNum(getBaseSocialeControl(form, 'my_NumLavSubTempoDeterminato')?.value);
        const my_NumLavSub = toNum(getBaseSocialeControl(form, 'my_NumLavSub')?.value);
        const errors = my_CkContrattiSecondoLivelloRegFiscaleAgevolatoControl.errors ? my_CkContrattiSecondoLivelloRegFiscaleAgevolatoControl.errors : {};
        const showError =
            my_UnitaNonSociUtil + my_UnitaSociUtil > 0 &&
            my_NumLavSubTempoDeterminato + my_NumLavSub > 0 &&
            isNilOrEmpty(my_CkContrattiSecondoLivelloRegFiscaleAgevolato) &&
            my_CkUtilizzaContrattiSecondoLivello === '1';

        addRemoveError(showError, errors, 'my_CkContrattiSecondoLivelloRegFiscaleAgevolato', {
            status: REQUIRED_STATUS,
        });

        my_CkContrattiSecondoLivelloRegFiscaleAgevolatoControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CtrlContrattiAdottatiSociLav: (form: FormGroup) => {
        const effettivitaBaseSocialeGroup = getBaseSocialeGroup(form);
        const my_CtrlContrattiAdottatiSociLavControl = getBaseSocialeControl(form, 'my_CtrlContrattiAdottatiSociLav');
        const my_ElContrattiUsatiSociLavoratoriFormArray = getFormArray(effettivitaBaseSocialeGroup, 'my_ContrattiUsatiSociLavoratori.my_ElContrattiUsatiSociLavoratori');
        const my_CkContrattoCollLavSub: string = getBaseSocialeControl(form, 'my_CkContrattoCollLavSub')?.value;
        const my_CkNormeSocioLavorat: string = getBaseSocialeControl(form, 'my_CkNormeSocioLavorat')?.value;
        const my_CkRedazRegolam: string = getBaseSocialeControl(form, 'my_CkRedazRegolam')?.value;
        const my_CkSocLavSub: string = getBaseSocialeControl(form, 'my_CkSocLavSub')?.value;
        const my_CkSocLavSubTempoDeterminato: string = getBaseSocialeControl(form, 'my_CkSocLavSubTempoDeterminato')?.value;
        const errors = my_CtrlContrattiAdottatiSociLavControl.errors ? my_CtrlContrattiAdottatiSociLavControl.errors : {};
        const showError =
            my_ElContrattiUsatiSociLavoratoriFormArray.length === 0 &&
            my_CkContrattoCollLavSub === '1' &&
            my_CkNormeSocioLavorat === '1' &&
            my_CkRedazRegolam === '1' &&
            (my_CkSocLavSubTempoDeterminato === '1' || my_CkSocLavSub === '1');

        addRemoveError(showError, errors, 'my_CtrlContrattiAdottatiSociLav', {
            status: 'Definirei contratti utilizzati.',
            message: "Inserire i contratti utilizzati dall'ente per i soci lavoratori.",
        });

        my_CtrlContrattiAdottatiSociLavControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ContrUsatiDesc: (form: FormGroup) => {
        const effettivitaBaseSocialeGroup = getBaseSocialeGroup(form);
        const formArray = getFormArray(effettivitaBaseSocialeGroup, 'my_ContrattiUsati.my_ElContrattiUsati');

        (formArray.controls as FormGroup[]).forEach((rowGroup: FormGroup) => {
            const control = getControl(rowGroup, 'my_ContrUsatiDesc');
            const value: string = control?.value;
            const errors = control.errors ?? {};

            const isDuplicate =
                !isNilOrEmpty(value) && (formArray.controls as FormGroup[]).filter((other: FormGroup) => getControl(other, 'my_ContrUsatiDesc')?.value === value).length > 1;

            addRemoveError(isDuplicate, errors, 'my_ContrUsatiDesc', {
                status: 'Il contratto è stato già inserito!',
            });

            control.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_ContrattiUsatiSociLavoratoriDesc: (form: FormGroup) => {
        const effettivitaBaseSocialeGroup = getBaseSocialeGroup(form);
        const my_ElContrattiUsatiSociLavoratoriFormArray = getFormArray(effettivitaBaseSocialeGroup, 'my_ContrattiUsatiSociLavoratori.my_ElContrattiUsatiSociLavoratori');
        const my_CkContrattoCollLavSub = toNum(getBaseSocialeControl(form, 'my_CkContrattoCollLavSub')?.value);
        my_ElContrattiUsatiSociLavoratoriFormArray?.controls?.forEach((c: FormGroup) => {
            const my_ContrattiUsatiSociLavoratoriDescControl = getControl(c, 'my_ContrattiUsatiSociLavoratoriDesc');
            const errors = my_ContrattiUsatiSociLavoratoriDescControl.errors ? my_ContrattiUsatiSociLavoratoriDescControl.errors : {};

            addRemoveError(isNilOrEmpty(my_ContrattiUsatiSociLavoratoriDescControl?.value) && my_CkContrattoCollLavSub === 1, errors, 'my_ContrattiUsatiSociLavoratoriDesc', {
                status: REQUIRED_STATUS,
            });

            my_ContrattiUsatiSociLavoratoriDescControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },
};

const myCkUtilizzaContrattiHelper = (form: FormGroup, targetPath: string, customError: FormValidationError = { status: 'Selezionare almeno un contratto' }) => {
    const targetControl = getBaseSocialeControl(form, targetPath);
    const my_CkUtilizzaContrattiSecondoLivello: string = getBaseSocialeControl(form, 'my_CkUtilizzaContrattiSecondoLivello')?.value;
    const my_CkUtilizzaContrattiSecondoLivelloAziendali: string = getBaseSocialeControl(form, 'my_CkUtilizzaContrattiSecondoLivelloAziendali')?.value;
    const my_UnitaNonSociUtil = toNum(getBaseSocialeControl(form, 'my_UnitaNonSociUtil')?.value);
    const my_UnitaSociUtil = toNum(getBaseSocialeControl(form, 'my_UnitaSociUtil')?.value);
    const my_NumLavSubTempoDeterminato = toNum(getBaseSocialeControl(form, 'my_NumLavSubTempoDeterminato')?.value);
    const my_NumLavSub = toNum(getBaseSocialeControl(form, 'my_NumLavSub')?.value);
    const my_CkUtilizzaContrattiSecondoLivelloTerrProvinciale = toNum(getBaseSocialeControl(form, 'my_CkUtilizzaContrattiSecondoLivelloTerrProvinciale')?.value);
    const my_CkUtilizzaContrattiSecondoLivelloTerrRegionale = toNum(getBaseSocialeControl(form, 'my_CkUtilizzaContrattiSecondoLivelloTerrRegionale')?.value);
    const errors = targetControl.errors ? targetControl.errors : {};
    const showError =
        toNum(toBoolean(my_CkUtilizzaContrattiSecondoLivelloAziendali)) +
            toNum(toBoolean(my_CkUtilizzaContrattiSecondoLivelloTerrProvinciale)) +
            toNum(toBoolean(my_CkUtilizzaContrattiSecondoLivelloTerrRegionale)) ===
            0 &&
        my_CkUtilizzaContrattiSecondoLivello === '1' &&
        my_UnitaNonSociUtil + my_UnitaSociUtil > 0 &&
        my_NumLavSubTempoDeterminato + my_NumLavSub > 0;

    addRemoveError(showError, errors, targetPath, customError);

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};
